import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";

export default function ({ children, call = () => {}, ...props }) {
    const raw_data = {
        rows: 10,
        page: 0
    };

    const [lazyState, setLazyState] = useState({
        first: 0,
        ...raw_data
    });

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);

    const onPageChange = (event) => {
        setLazyState(event);
    };

    useEffect(() => {
        async function loadData() {
            const queryObject = {
                ...lazyState,
                pageIndex: 1,
                pageSize: lazyState.rows * (lazyState.page + 1),
            };

            setLoading(true);
            try {
                const r = await call(queryObject);
                setTotalRecords(r?.count || 0);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        loadData();
    }, [lazyState]);

    return (
        <DataTable
            {...props}
            value={props.value}
            first={lazyState.first}
            size="small"
            scrollable
            loading={loading}
            className="datatable-responsive"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            emptyMessage="No data found."
            resizableColumns
            columnResizeMode="expand"
            selectionMode="checkbox"
            onSelectionChange={(e) => setSelectedItems(e.value)}
            selection={selectedItems}
            selectionPageOnly
            rows={lazyState.rows}
            rowsPerPageOptions={[10, 20, 50]}
            totalRecords={totalRecords}
            onPage={onPageChange}
            paginator
            // paginatorLeft={<></>}
        >
            {children}
        </DataTable>
    );
}
